// import Chart from 'chart.js/auto';
import $ from "jquery";

function destroyHomeIndex() {
    destroyChart(document.getElementById('myChart'));
    if(document.getElementById('home-index')) {
        closeModals()
    }
}

function setupHomeIndex() {
    if(document.getElementById('home-index')) {
        let canvas = document.getElementById('myChart');
        if(canvas === undefined || canvas === null) {
            console.warn('chart element is missing!!\ncanvas:');
            console.log(canvas);
        } else {
            destroyChart(canvas);
            let ctx = canvas.getContext('2d');
            new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: JSON.parse(ctx.canvas.dataset.labels),
                    datasets: [{
                        label: 'Baterías vendidas',
                        data: JSON.parse(canvas.dataset.batteries),
                        backgroundColor: 'rgb(121,134,203)',
                        borderColor: 'rgb(92,107,192)',
                        borderWidth: 1
                    },
                    {
                        label: 'Productos vendidos',
                        data: JSON.parse(canvas.dataset.products),
                        backgroundColor: 'rgb(186,104,200)',
                        borderColor: 'rgb(171,71,188)',
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true
                }
            });
            console.log("Chart created!");
        }
    }
}

function destroyChart(canvas) {
    if(canvas !== undefined && canvas !== null){
        let existingChart = Chart.getChart(canvas);
        if (existingChart) {
            existingChart.destroy();
            console.log("Chart destroyed!");
        }
    }
}
function closeModals() {
    if ($('#inventarioModal').hasClass('show')) {
        $('#inventarioModal').removeClass('show');
    }
    if ($('#venderModal').hasClass('show')) {
        $('#venderModal').removeClass('show');
    }
    if ($('#comprarModal').hasClass('show')) {
        $('#comprarModal').removeClass('show');
    }
    // Limpiar residuos de Bootstrap que suelen quedarse trabados
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open').css('padding-right', '');
}

if(document.getElementById('home-index')) {
    closeModals()
}

document.addEventListener("turbolinks:load", setupHomeIndex);
document.addEventListener('turbolinks:before-cache', destroyHomeIndex);

// Rails 7 & Hotwire/Turbo
// document.addEventListener('turbo:load', setupUserForm);
// document.addEventListener('turbo:before-cache', teardownUserForm);